function FormatDate(dateString) {
  if (dateString == null || dateString === '') return '';

  const raw = String(dateString).trim();
  if (/^\d{2}-\d{2}-\d{4}/.test(raw)) {
    return raw;
  }

  const normalized = raw.includes('T') || /[zZ]$/.test(raw)
    ? raw
    : raw.replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return raw;

  const hasTime = /T|\d{2}:\d{2}/.test(raw);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(hasTime ? {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    } : {}),
  }).formatToParts(date);

  const get = (type) => parts.find((part) => part.type === type)?.value || '';
  const dmy = `${get('day')}-${get('month')}-${get('year')}`;
  if (!hasTime || !get('hour')) return dmy;

  const period = (get('dayPeriod') || '').toUpperCase();
  return `${dmy} ${get('hour')}:${get('minute')} ${period}`;
}

export { FormatDate };
